








































import { Component } from "vue-property-decorator";
import { EMOJIS } from "@/resources/constants/emojis";
import { i18n } from "@/resources/locales";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
import { CHAT_TYPE } from "@/resources/constants/chat";
import meeting from "@/store/modules/meeting";
import { MEETING_TYPE } from "@/resources/constants/meeting";
@Component({
  name: "emoji-selector-component",
})
export default class EmojiSelectorComponent extends mixins(
  NotificationEvent,
  FloatMenuAnimation
) {
  EMOJIS = EMOJIS;
  localSpaceUSer;

  constructor() {
    super();
    this.localSpaceUSer = this.$store.getters["UserStore/getSpaceUser"];
  }
  get blockChangeEmoji() {
    return this.$store.getters["SystemStore/getBlockChangeEmoji"];
  }
  get getIsCall(): boolean {
    return this.$store.getters["SidebarStore/getOpenCall"];
  }
  getEmoji(emoji: string): void {
    const emojis = EMOJIS;
    return emojis.filter((a) => a.code === emoji)[0].emoji;
  }
  selectEmoji(emoji: string): void {
    const blockChangeEmoji =
      this.$store.getters["SystemStore/getBlockChangeEmoji"];
    if (!blockChangeEmoji) {
      this.$store.dispatch("SystemStore/setBlockChangeEmojiAction", true);
      const spaceId = this.$store.getters["SpaceStore/getSpace"].id;
      const roomId = this.$store.getters["MeetingStore/getRoomId"];
      const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
      this.$store.dispatch("SpaceStore/sendEmojiReactionAction", {
        spaceId: spaceId,
        data: { emoji: emoji, room: roomId || roomId !== 0 ? roomId : null },
      });
      if (
        meetingType === MEETING_TYPE.WEBINAR ||
        meetingType === MEETING_TYPE.MEETING
      )
        this.$store.dispatch("ChatStore/sendRoomMessageAction", {
          roomId,
          data: {
            chatMessage: emoji,
            chatMessageType: TYPES_MESSAGES.REACTION,
          },
        });
      setTimeout(() => {
        this.$store.dispatch("SystemStore/setBlockChangeEmojiAction", false);
      }, 3000);
    }
  }
  closeSelector(): void {
    setTimeout(() => {
      this.closeEmojiSelector();
    }, 50);
    setTimeout(() => {
      this.$store.dispatch("FloatMenuStore/setOpenEmojiSelectorAction", false);
    }, 200);
  }
  showNotification(): void {
    this.onWarning(
      i18n.t(""),
      i18n.t("notifications.warningMessages.emojiIsNotChangedOnCall"),
      "none"
    );
  }
}
